export const GLOBAL_SKEW = 22 // global used skew is 22 degrees (tan(a) = 94/238 => a ~ 22 degrees)
export const POPUP_STORAGE_KEY = 'sport050-popups-seen'
